import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Form, Button, Input, Card, Row, Col } from 'antd';
import { LockTwoTone, MailTwoTone } from '@ant-design/icons';
import IntlMessages from '../../components/IntlMessage';
import logo from '../../assets/img/logo-login.png';
// import { LoadingScreen } from '../../components/LoadingScreen';
// import { LoadingWithProgress } from '../../components/LoadingWithProgress';

// actions
import { login } from '../../redux/actions/AuthActions';
// const { Text } = Typography;

class Login extends Component {
  state = {
    loading: false,
    isLoading: false,
  };

  onFinish = (values) => {
    this.setState({ isLoading: true });

    var dataSub = {
      username: values.username,
      password: values.password,
    };
    var a = this;
    this.setState({ loading: true }, () => {
      a.props
        .login(dataSub)
        .then((res) => {
          console.log('res', res);
          a.setState({ loading: false });
        })
        .catch((err) => a.setState({ loading: false }));
    });
    // setTimeout(()=>{ this.setState({isLoading:false});
    //  },2000)
  };

  onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  render() {
    var { loading } = this.state;
    var { isLoading } = this.state;
    var { authUser } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    // if (isLoading) {
    //     return (
    //         <LoadingWithProgress/>
    //             )
    // }

    if (authUser) return <Redirect to="/" />;

    return (
      <div className="fullscreen">
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: '100vh' }}>
          <Col xs={24} xl={8}>
            <Card>
              <Row type="flex" justify="center">
                {<img src={logo} className="login-logo" />}
                <div style={{}}></div>
              </Row>
              {/* <Row type="flex" justify="center">

                                <Text strong>Easy travel</Text>
                            </Row> */}
              <p></p>
              <Form
                {...formItemLayout}
                layout="vertical"
                initialValues={{
                  remember: true,
                }}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                size="large">
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: (
                        <IntlMessages id="global.email_mobile_required" />
                      ),
                    },
                  ]}>
                  <Input
                    prefix={<MailTwoTone className="site-form-item-icon" />}
                    placeholder="Email or Mobile"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: <IntlMessages id="global.password_required" />,
                    },
                  ]}>
                  <Input.Password
                    prefix={<LockTwoTone className="site-form-item-icon" />}
                    placeholder="Password"
                  />
                </Form.Item>

                {/* <Row justify="space-between">
                                    <Col></Col>
                                    <Col><Link to='/resetpassword'><IntlMessages id="global.forgot_password" /></Link></Col>
                                </Row> */}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    loading={this.state.loading}>
                    <IntlMessages id="global.signin" />
                  </Button>
                </Form.Item>

                {/* <Form.Item>

                                    <Link to='/signup'>
                                        <Button
                                            type="secondary"
                                            htmlType="button"
                                            className="login-form-button"
                                            loading={this.state.loading}
                                        >
                                            <IntlMessages id="global.signup" />
                                        </Button>

                                    </Link>


                                </Form.Item> */}
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.auth.authUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    login: (data) => dispatch(login(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
